import { message } from 'antd'
import mapValues from 'lodash/mapValues'
import isNil from 'lodash/isNil'
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import humps from 'humps'
import api from '../../api'
import { toPath } from '../../routes'
import { PageHeader } from '../Common'
import PracticeForm, { NON_FILE_PRACTICE_FIELDS } from './PracticeForm'

export default function NewPractice() {
  const navigate = useNavigate()
  const goToList = useCallback(() => navigate(toPath.practices()), [navigate])

  const onSubmit = useCallback(
    async (practiceValues, { setErrors }) => {
      try {
        const fd = new FormData()

        NON_FILE_PRACTICE_FIELDS.forEach(field => {
          const fieldValue = practiceValues[field]

          if (isNil(fieldValue)) return

          if (Array.isArray(fieldValue)) {
            // Rails parses repeated `field[]` entries as an array; a single
            // blank entry clears the field (the API drops blank values).
            const key = `${humps.decamelize(field)}[]`

            if (fieldValue.length) {
              fieldValue.forEach(entry => fd.append(key, entry))
            } else {
              fd.append(key, '')
            }
          } else {
            fd.append(humps.decamelize(field), fieldValue)
          }
        })

        if (Array.isArray(practiceValues.logo)) {
          fd.append('logo', practiceValues.logo[0])
        }

        await api.practices.createPractice(fd)
        message.success('Practice successfully created')
        goToList()
      } catch (e) {
        if (e.response && e.response.errors) {
          setErrors(mapValues(e.response.errors, error => error[0]))
        } else {
          message.error('Oops, we had a problem. Please try submitting again')
        }
      }
    },
    [goToList],
  )

  return (
    <div>
      <PageHeader title="New Practice" onBack={() => navigate(-1)} />
      <PracticeForm onSubmit={onSubmit} />
    </div>
  )
}
